import { Helmet } from "react-helmet"
import React from "react"
import { getFooterBreadcrumbComponent } from "./utils"
import { useLocation } from "@reach/router"

export const FooterBreadcrumbs = ({ breadcrumb_array }) => {
  const { pathname } = useLocation()

  const breadcrumb_schema_org_data = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumb_array
      .map(({ content, type, link, ignore_json }, index) => {
        if (ignore_json) {
          return null
        }
        return {
          "@type": "ListItem",
          position: index + 1,
          name: content,
          item:
            type === "BreadcrumbLink"
              ? `https://bi-medien.de${link}`
              : `https://bi-medien.de${pathname}`,
        }
      })
      .filter((item) => !!item),
  })

  return (
    <div className="has-background-mitternachtsblau-10">
      <Helmet>
        <script type="application/ld+json">{breadcrumb_schema_org_data}</script>
      </Helmet>
      <div
        x-bi-data-nosnippet="true"
        className="container py-1 px-3 is-clipped"
      >
        <div style={{ display: "flex" }}>
          <nav
            className="level is-mobile"
            aria-label="breadcrumbs"
            style={{ maxWidth: "100%" }}
          >
            <div className="level-left page-breadcrumbs no-scrollbar">
              {breadcrumb_array.map(getFooterBreadcrumbComponent)}
            </div>
          </nav>
        </div>
      </div>
    </div>
  )
}
